import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  private currentUserSubject = new BehaviorSubject<any>(null);
  private credentialsSubject = new BehaviorSubject<any>(null);

  currentUser$: Observable<any> = this.currentUserSubject.asObservable();
  credentials$: Observable<any> = this.credentialsSubject.asObservable();

  setUser(user: any): void {
    this.currentUserSubject.next(user);
  }

  setCredentials(credentials: any): void {
    this.credentialsSubject.next(credentials);
  }

  get currentUser(): any {
    return this.currentUserSubject.value;
  }

  get credentials(): any {
    return this.credentialsSubject.value;
  }
}